import * as React from "react"
import type { SVGProps } from "react"
const SvgSendScheduled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 19.21v-13q0-.54.44-.83a1 1 0 0 1 .94-.1l9.97 4.18q.47.2.57.6.1.38-.05.73-.14.35-.5.55-.34.2-.82 0L5 7.7v3.5l3.1.78a.7.7 0 0 1 .41.27 1 1 0 0 1 .14.45 1 1 0 0 1-.14.45.7.7 0 0 1-.41.28L5 14.2v3.5l3.73-1.57q.47-.2.8-.01a1.1 1.1 0 0 1 .55 1.27q-.1.4-.58.59l-5.1 2.15a1 1 0 0 1-.95-.09.9.9 0 0 1-.45-.84m14 3.5a4.8 4.8 0 0 1-3.54-1.46A4.8 4.8 0 0 1 12 17.71q0-2.07 1.46-3.53Q14.93 12.7 17 12.7c2.07 0 2.56.5 3.54 1.47A4.8 4.8 0 0 1 22 17.7q0 2.09-1.46 3.54A4.8 4.8 0 0 1 17 22.71m.5-5.2v-2.3a.5.5 0 0 0-.15-.35.5.5 0 0 0-.7 0 .5.5 0 0 0-.15.35v2.28a1 1 0 0 0 .3.72l1.5 1.5a.5.5 0 0 0 .7 0 .5.5 0 0 0 0-.7z" />
  </svg>
)
export default SvgSendScheduled
